module.exports = __webpack_public_path__ + "881d0bce594d19a4682deafd26dd1ca4.jpg";